import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  right: 0;
  bottom: 0;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.3);
  padding: 20px 10px 20px 20px;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ScrollItem = styled.div``;
